import { create } from "zustand";

export const useHeaderTextStore = create((set) => ({
  headerText: "",
  setHeaderText: (title = "") => {
    let prefix = "EP-TR-CMS";
    set({ headerText: title === prefix ? title : `${prefix} / ${title}` });
  },
}));
